var map = {
	"./Gilroy-Bold.woff": 85907,
	"./Gilroy-ExtraBold.woff": 44772,
	"./Gilroy-Light.woff": 22268,
	"./Gilroy-Medium.woff": 99665,
	"./Gilroy-Regular.woff": 66523,
	"./Gilroy-SemiBold.woff": 3192,
	"./noto-sans-sc-v25-chinese-simplified-regular.woff": 8605
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89074;